// @flow
import React from 'react';
import { silverGrey } from '../colors';
import DefaultTheme from './theme';
/*::
import type { Node } from 'react';

export type DataPresenterThemeType = {|
  PlaceHolder: * => Node,
|};

type Props = {|
  nodata: boolean,
  loading: boolean,
  width?: number,
  height?: number,
  bgcolor?: string,
  noDataComponent?: Node,
  theme?: DataPresenterThemeType,
  children: Node,
|};
*/

var DataPresenter = function DataPresenter(_ref
/*: Props */
) {
  var nodata = _ref.nodata,
      loading = _ref.loading,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 4 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 1 : _ref$height,
      _ref$bgcolor = _ref.bgcolor,
      bgcolor = _ref$bgcolor === void 0 ? silverGrey() : _ref$bgcolor,
      _ref$noDataComponent = _ref.noDataComponent,
      noDataComponent = _ref$noDataComponent === void 0 ? '-' : _ref$noDataComponent,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme,
      children = _ref.children;

  if (loading) {
    return /*#__PURE__*/React.createElement(theme.PlaceHolder, {
      width: width,
      height: height,
      bgcolor: bgcolor
    }, "\xA0");
  }

  if (nodata) {
    return noDataComponent;
  }

  return children;
};

export default DataPresenter;